import React from 'react'
import { Page } from '../components/ui/Page'
import { Body } from '../components/layout/Body';

export default function TermsPage(props: any) {
	return (
		<Page>
			<Body title="Sicherheit" id={props.id}></Body>
		</Page>
	)
}
